import { render, staticRenderFns } from "./DfAdminForm.vue?vue&type=template&id=13e9957a&"
import script from "./DfAdminForm.vue?vue&type=script&lang=js&"
export * from "./DfAdminForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports